import { useNavigate } from "react-router-dom";
import queryString from "query-string";
import Cookies from 'js-cookie';

const Auth = ({
    location,
    profile,
    receiveProfile,
    receiveTokens
}) => {
    const navigate = useNavigate();
    const hash = window.location.hash;
    const response = queryString.parse(hash);
    if (response.error) {
        navigate('/error', { replace: true, state: { message: response.error } });
    } else {
        Cookies.set("olt", response.id_token);
        window.location = process.env.PUBLIC_URL;
    }
};

export default Auth;